"use client"

import { ComponentConfig, CustomField } from "@measured/puck"
import { useEffect } from "react"
import { useWebsiteDomainStore, WebsiteSelect } from "../../../components/WebsiteSelect"
import { RenderConfig } from "./RenderConfig"
import { LatestNewsProps } from "./types"

function WebsiteSelectWrapper(props: any) {
    const setWebsiteDomain = useWebsiteDomainStore((state) => state.setWebsiteDomain)

    useEffect(() => {
        if (props.value) {
            setWebsiteDomain(props.value)
        }
    }, [props.value, setWebsiteDomain])

    return (
        <WebsiteSelect
            value={props.value || ""}
            onChange={(value) => {
                props.onChange(value || undefined)
            }}
            {...(props as any)}
        />
    )
}

export const LatestNews: ComponentConfig<LatestNewsProps> = {
    label: "Tamda Foods | Latest News",
    fields: {
        websiteDomain: {
            label: "Website Domain",
            type: "custom",
            render: (props) => <WebsiteSelectWrapper {...props} />,
        } as CustomField<string | undefined>,
        title: {
            label: "Title",
            type: "text",
        },
        className: {
            label: "Class Name",
            type: "text",
        },
    },
    defaultProps: {
        websiteDomain: "tamdagroup.eu",
        title: "TIN MỚI NHẤT",
        className: "",
    },
    ...RenderConfig,
}
